import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import * as firebase from 'firebase';

@Injectable({
  providedIn: 'root'
})
export class HttpHelperService {

  public baseUploadURL: any = "https://codexia.xyz/cardioapp/upload.php";
  constructor(public http: HttpClient) {
  }

  uploadImageFile(formData: FormData) {
    return this.http.post(this.baseUploadURL, formData).toPromise();
  }

  uploadVideoFile(formData: FormData) {
    return this.http.post(this.baseUploadURL, formData).toPromise();
  }

  uploadFiles(formData: FormData) {
    return this.http.post(this.baseUploadURL, formData).toPromise();
  }


  getEmailHTML(data) {

    var html = `<!DOCTYPE html
    PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
 <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml"
    xmlns:o="urn:schemas-microsoft-com:office:office">
 
 <head>
    <meta http-equiv="Content-type" content="text/html; charset=utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="format-detection" content="date=no" />
    <meta name="format-detection" content="address=no" />
    <meta name="format-detection" content="telephone=no" />
    <meta name="x-apple-disable-message-reformatting" />
 
    <style type="text/css" media="screen">
       body {
          padding: 0 !important;
          margin: 0 !important;
          display: block !important;
          max-width: 100% !important;
          width: 100% !important;
          background: #8a8c9e !important;
          -webkit-text-size-adjust: none
       }
       a {
          text-decoration: none
       }
       p {
          padding: 0 !important;
          margin: 0 !important
       }
       img {
          -ms-interpolation-mode: bicubic;
       }
 
       @media only screen and (max-device-width: 480px),
       only screen and (max-width: 480px) {
          .mobile-shell {
             width: 100% !important;
             max-width: 100% !important;
          }
          .m-center {
             text-align: center !important;
          }
 
          .m-left {
             margin-right: auto !important;
          }
          .center {
             margin: 0 auto !important;
          }
          .td {
             width: 100% !important;
             min-width: 100% !important;
          }
          .fluid-img img {
             width: 100% !important;
             max-width: 100% !important;
             height: auto !important;
          }
          .text-white-two {
             font-size: 15px !important;
             line-height: 18px;
          }
          .text-white {
             font-size: 16px !important;
             line-height: 20px;
          }
          .h2-white {
             font-size: 38px !important;
             line-height: 44px !important;
          }
          .h3-white {
             font-size: 24px !important;
             line-height: 30px !important;
          }
          .content {
             padding: 20px 15px !important;
          }
          .section-inner {
             padding: 0px !important;
          }
          .main {
             padding: 0px !important;
          }
       }
    </style>
 </head>
 
 <body class="body"
   style="padding:0 !important; margin:0 !important; display:block !important; min-width:100% !important; width:100% !important; background:#eeeeee; -webkit-text-size-adjust:none;">
   <table width="100%" border="0" cellspacing="0" cellpadding="0" bgcolor="#eeeeee">
      <tr>
         <td align="center" valign="top">
        
            <table width="100%" border="0" cellspacing="0" cellpadding="0">
               <tr>
                  <td align="center">
                     <table width="600" border="0" cellspacing="0" cellpadding="0" class="mobile-shell"
                        bgcolor="#f8fcfc">
                        <tr>
                           <td class="td"
                              style="width:600px; max-width:600px; font-size:0pt; line-height:0pt; padding:0; margin:0; font-weight:normal;">
                              <table width="100%" border="0" cellspacing="0" cellpadding="0" bgcolor="#f8fcfc">
                                 <tr>
                                    <td style="padding: 10px 0px 10px 0px;">
                                       <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                          <tr>
                                             <td class="m-center"
                                                style="font-size:0pt; line-height:0pt; text-align:center;">
                                                <a href="#" target="_blank"> <img
                                                      src="https://i.ibb.co/ZXbgQNp/logo.png" width="180"
                                                      style="max-width:180px;" border="0" alt="" /></a>
                                             </td>
                                          </tr>
                                       </table>
                                    </td>
                                 </tr>
                              </table>
                              <table width="100%" border="0" cellspacing="0" cellpadding="0" bgcolor="#f8fcfc">
                                 <tr>
                                    <td class="content-two" style="padding:10px 30px 10px;">
                                       <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                       
                                          <tr>
                                             <td class="text-white "
                                                style="color:#555a5d; font-family:  Helvetica, sans-serif;  font-size:24px; line-height:26px;   text-align:center; padding-bottom:15px;">
                                                ${data.title}
                                             </td>
                                          </tr>
                                       </table>
                                    </td>
                                 </tr>
                              </table>
                              <table width="100%" border="0" cellspacing="0" cellpadding="0" bgcolor="#ffffff">
                                 <tr>
                                    <td class="content" style="padding:30px 30px;">
                                       <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                          <tr>
                                             <td class="text-white "
                                                style="color:#555a5d; font-family:  Helvetica, sans-serif;  font-size:18px; line-height:22px;   text-align:left; padding-bottom:15px;">
                                                Dear User,
                                             </td>
                                          </tr>
                                          <tr>
                                             <td class="text-white "
                                                style="color:#555a5d; font-family:  Helvetica, sans-serif;  font-size:18px; line-height:22px;   text-align:left; padding-bottom:15px;">
                                                ${data.message}
                                             </td>
                                          </tr>
                                        
                                          <tr>
                                             <td class="text-white "
                                                style="color:#555a5d; font-family:  Helvetica, sans-serif;  font-size:18px; line-height:22px;   text-align:left;  padding-bottom:15px;">
                                                Regards, <br>
                                                <strong>Orbit</strong>
                                             </td>
                                          </tr>
                                       </table>
                                    </td>
                                 </tr>
                              </table>
                             
                              <table width="100%" border="0" cellspacing="0" cellpadding="0" bgcolor="#f8fcfc">
                                 <tr>
                                    <td class="content" style="padding:20px 30px 15px;">
                                       <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                          <tr>
                                             <td
                                                style="color:#000000; font-family:Helvetica, sans-serif; font-size:14px; line-height:22px; text-align:center; text-transform:uppercase; padding-bottom:10px;">
                                                f o l l o w &nbsp; u s </td>
                                          </tr>
                                          <tr>
                                             <td align="center" style="padding-bottom:10px;">
                                                <table border="0" cellspacing="0" cellpadding="0">
                                                   <tr>
                                                      <td class="img" width="50"
                                                         style="font-size:0pt; line-height:0pt; text-align:left;"><a
                                                            href="#" target="_blank"><img
                                                               src="https://i.ibb.co/Jr437ZV/faceook.png" width="40"
                                                               height="40" style="max-width:40px;" border="0"
                                                               alt="" /></a></td>
                                                      <td class="img" width="50"
                                                         style="font-size:0pt; line-height:0pt; text-align:left;"><a
                                                            href="#" target="_blank"><img
                                                               src="https://i.ibb.co/nPXd7yZ/instagram.png" width="40"
                                                               height="40" style="max-width:40px;" border="0"
                                                               alt="" /></a></td>
                                                      <td class="img" width="50"
                                                         style="font-size:0pt; line-height:0pt; text-align:left;"><a
                                                            href="#" target="_blank"><img
                                                               src="https://i.ibb.co/yysz9RS/twitter.png" width="40"
                                                               height="40" style="max-width:40px;" border="0"
                                                               alt="" /></a></td>
                                                      <td class="img" width="50"
                                                         style="font-size:0pt; line-height:0pt; text-align:left;"><a
                                                            href="#" target="_blank"><img
                                                               src="https://i.ibb.co/SntYHkY/linkedin.png" width="40"
                                                               height="40" style="max-width:40px;" border="0"
                                                               alt="" /></a></td>
                                                   </tr>
                                                </table>
                                             </td>
                                          </tr>
                                          <tr>
                                             <td
                                                style="color:#000000; font-family:Helvetica, sans-serif; font-size:14px; line-height:20px; text-align:center;">
                                                Copyright &copy; 2021. All Rights Reserved</td>
                                          </tr>
                                       </table>
                                    </td>
                                 </tr>
                              </table>
                           </td>
                        </tr>
                     </table>
                  </td>

               </tr>
            </table>
         </td>
      </tr>
   </table>
</body>
 
 </html>`

    return html;
  }


  sendEmailNotifications(emailsList, data) {
    if (emailsList.length) {
       //emailsList.push('asimilyas527@gmail.com')
      var self = this, htmlBody = self.getEmailHTML(data), sendEmail = firebase.functions().httpsCallable('sendEmail');
      sendEmail({
        to: emailsList,
        subject: data.title,
        body: htmlBody,
      }).then((result) => {
        console.log(result);
      }).catch((error) => {
        console.log(error);
      });
    }

  }

}
